const PositionComponent = () => import('@/views/position/PositionView')

export default [
    {
        path:'/PositionIndex',
        name:'PositionIndex',
        component:PositionComponent
    }
]